import React, { FC } from "react";
import styles from "./ExCalendarTile.module.scss";
/*
interface ExCalendarTileProps {
  isSelected: boolean;
  isDisabled: boolean;
  showAsDisabled?: boolean;
  day?: string;
  numDay?: string;
  month?: string;
  isUnavailable: boolean;
  showJustYear?: boolean;
  year?: string;
}
*/
const ExCalendarTile = ({
  isSelected,
  isDisabled,
  showAsDisabled,
  day,
  numDay,
  isUnavailable,
  month,
  year,
  showJustYear,
  isNoAvailableSlots
}) => {
  return (
    <div
      className={
        isSelected
          ? styles.ExCalendarTileSelected
          : showAsDisabled || isDisabled
          ? isSelected
            ? styles.ExCalendarTileSelected
            : styles.ExCalendarTileDisabled : isNoAvailableSlots ? styles.ExCalendarTileDisabledNoSlots
          : `${styles.ExCalendarTile} ${styles.hover}`
      }
    >
      {showJustYear ? (
        <span className={styles.yearLabel}>{year}</span>
      ) : (
        <>
          <span
            className={!isSelected ? styles.dayLabel : styles.dayLabelSelected}
          >
            {day.toLowerCase()}
          </span>
          {isUnavailable && !isSelected && <div className={styles.stroke}></div>}
          <span
            className={
              !isSelected ? styles.numDayLabel : styles.numDayLabelSelected
            }
          >
            {numDay}
          </span>
          <span
            className={
              !isSelected ? styles.monthLabel : styles.monthLabelSelected
            }
          >
            {month}
          </span>
        </>
      )}
    </div>
  );
};

ExCalendarTile.defaultProps = {
  showJustYear: false,
};

export default ExCalendarTile;
